import { lazy } from 'react';

const AlumniAffiliationModal = lazy(() =>
  import('./components/AlumniAffiliationModal'),
);
const EducationAffiliationModal = lazy(() =>
  import('./components/EducationAffiliationModal'),
);
const EmploymentAffiliationModal = lazy(() =>
  import('./components/EmploymentAffiliationModal'),
);

export default {
  ALUMNI_AFFILIATION: AlumniAffiliationModal,
  EDUCATION_AFFILIATION: EducationAffiliationModal,
  EMPLOYMENT_AFFILIATION: EmploymentAffiliationModal,
};
